/**
 * Customer (mijoz) Zod schemalar
 *
 * Kanonik:
 *   - phone format: +998 XX XXX XX XX (common phoneSchema bilan)
 *   - VIP: orderCount >= TenantSettings.vipOrderCount (default 10)
 */
import { z } from 'zod';
import { phoneSchema, uuidSchema } from './common.schema.js';
// ─── Customer trust level ─────────────────────────────────────────
// VIP       = va'da qilgan vaqtida to'laydi (to'lovda avtomatik beriladi)
// ISHONCHLI = qarz berish bemalol (verified trusted customer)
// ORTACHA   = va'dadan bir necha kun kechikib to'laydi (avtomatik)
// ODDIY     = qarz qo'shishda inline warning (default — yangi mijoz);
//             "bermayman" deganlar qo'lda shu darajaga tushiriladi
export const customerTrustEnum = z.enum(['VIP', 'ISHONCHLI', 'ORTACHA', 'ODDIY']);
// ─── Create customer ──────────────────────────────────────────────
export const createCustomerSchema = z.object({
    name: z.string().min(2, 'Ism kamida 2 ta belgi').max(100),
    surname: z.string().max(100).optional(),
    phone: phoneSchema,
    email: z.string().email("Noto'g'ri email").max(100).optional().or(z.literal('')),
    birthday: z.string().datetime().optional(),
    note: z.string().max(2000).optional(),
    trustLevel: customerTrustEnum.default('ODDIY'),
    // VIP mijoz — alohida belgi (trustLevel'dan mustaqil). Mijozlar sahifasidagi
    // "VIP" segment kartasi shu flag bo'yicha filtrlaydi. Avval bu maydonni
    // O'RNATIB BO'LMASDI (faqat filtr/stats'da bor edi) — VIP doim 0 chiqardi (bug).
    isVip: z.boolean().optional(),
    // Kredit limiti — null = standart default (5 mln); 0 = limitsiz; >0 = shu qiymat.
    // Limitdan oshish faqat zalog yoki EGASI override bilan.
    creditLimit: z.number().min(0).max(1_000_000_000).nullable().optional(),
    // Zalog (kafolat) — limitni kengaytiradi (effektiv chegara = limit + zalog qiymati)
    collateralValue: z.number().min(0).max(1_000_000_000).nullable().optional(),
    collateralNote: z.string().max(500).optional().or(z.literal('')),
    // Manzil va joylashuv
    address: z.string().max(500).optional(),
    locationLink: z.string().url("Noto'g'ri joylashuv linki").max(500).optional().or(z.literal('')),
    latitude: z.number().min(-90).max(90).optional(),
    longitude: z.number().min(-180).max(180).optional(),
    // Mashina
    carModel: z.string().max(100).optional(),
    carPlate: z.string().max(20).optional(),
});
// ─── Update customer (barcha fieldlar optional) ───────────────────
export const updateCustomerSchema = createCustomerSchema.partial();
// ─── Customer query (ro'yxat olish) ───────────────────────────────
export const customerQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    search: z.string().max(100).optional(),
    isVip: z.coerce.boolean().optional(),
    // Segment kartalar filtri (Mijozlar sahifasi): ishonchli/oddiy + qarzi bor.
    trustLevel: customerTrustEnum.optional(),
    hasDebt: z.coerce.boolean().optional(),
    storeId: uuidSchema.optional(),
    sortBy: z.enum(['name', 'createdAt', 'orderCount', 'totalSpent']).default('createdAt'),
    sortOrder: z.enum(['asc', 'desc']).default('desc'),
    // Keyset pagination — oxirgi element kursori (<sortValue>|id ICHKI base64).
    // Berilganda OFFSET emas, keyset ishlatiladi (10k+ da O(1)).
    cursor: z.string().max(200).optional(),
});
//# sourceMappingURL=customer.schema.js.map